import { Badge } from "evergreen-ui";
import React from "react";

interface IProps {
  status?: any;
}
const Status: React.SFC<IProps> = ({ status }) => {
  switch (status) {
    case "Approved":
      return <Badge color="green">{status}</Badge>;
    case "Pending":
      return <Badge color="yellow">{status}</Badge>;
    case "Cancelled":
      return <Badge color="red">{status}</Badge>;
    case "Rejected":
      return <Badge color="red">{status}</Badge>;
    default:
      return <Badge color="neutral">{status}</Badge>;
  }
};

export default Status;
